import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import { Routes } from '@angular/router';
import {
  OpinionOnIssuingADecisionApplicationDataComponent
} from './sections/opinion-on-issuing-a-decision-application-data/opinion-on-issuing-a-decision-application-data.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';

export const stages: string[] = [
  'Dane wniosku',
  'Inwestor',
  'Zgody',
  'Załączniki'
];

export const investorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../zgody',
  customTitles: {
    sectionTitle: 'Inwestor',
    tag: 'investor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!'
  }
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../inwestor',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const opinionOnIssuingADecisionRoutes: Routes = [
  {
    component: OpinionOnIssuingADecisionApplicationDataComponent,
    path: 'dane-wniosku'
  },
  {
    component: OpinionOnIssuingADecisionApplicationDataComponent,
    path: ':appId/dane-wniosku'
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: investorDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'dane-wniosku', pathMatch: 'prefix' }
];
